
//@ts-ignore
class Index extends Game.src.component.AutoplayComponent {
    async autoplayRequest(): Promise<void> {

        //@ts-ignore
        if (game.store.gameData.bonusGame.isPlaying()) {
            //@ts-ignore

            await this.onRunAutoplay();

            return;
        }

        await super.autoplayRequest();
    }
}

//@ts-ignore
Game.src.component.AutoplayComponent = Index;
